import { useForm as createUseForm } from "@ant-design-vue/use";
import { Button } from "ant-design-vue";
import lodash from "lodash";
import { defineAsyncComponent, toRaw } from "vue";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { initUseForm } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { createManageExportCsv, createPage, onClickReport } from "../../../../utils/page";
import { validateError } from "../../../../utils/validate";
import { openModalReportList } from "../../report/report.logic";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const { isLoading, setIsLoading } = createLoading();

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createColumns = ({ props }) => {
    const { visibleSamplingProduct, visibleTestReport } = props;
    const columns = [];
    if (visibleSamplingProduct) {
        columns.push(
            createColumnDate({
                title: () => i18n.global.t("model.samplingRequest.samplingCollectDate"),
                dataIndex: "refSamplingRequest.samplingCollectDate",
                align: "center"
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.samplingProduct.samplingNo"),
                dataIndex: "samplingNo",
                align: "center"
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.code"),
                dataIndex: "refCompanyProduct.refProduct.code",
                width: 200,
                align: "center"
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.nameTh"),
                dataIndex: "refCompanyProduct.refProduct.nameTh",
                width: 200
            })
        );
        columns.push(
            createColumnSelect({
                title: () => i18n.global.t("model.samplingProduct.refStatus"),
                dataIndex: "refStatus.value",
                customRender: ({ record }) => {
                    let text = record.refStatus?.value;
                    if (record.refStatus?.key === "Send Result" && record?.refSamplingRequest?.refSamplingStatus?.key === "Review Result") {
                        text += ` (${record?.refSamplingRequest?.refSamplingStatus?.value})`;
                    }
                    return <div>{text}</div>;
                },
                inputProp: () => ({
                    list: ({ searchQuery }) =>
                        store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
                            group: "SAMPLING_PRODUCT_STATUS",
                            key: searchQuery,
                            value: searchQuery,
                            options: { force: true }
                        }),
                    renderLabel: ({ item }) => <div>{item.value}</div>
                }),
                align: "center",
                search: {
                    name: "refStatus.id"
                }
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.samplingProduct.refAcceptanceStatus"),
                dataIndex: "refAcceptanceStatus.value",
                align: "center"
            })
        );
    }
    if (visibleTestReport) {
        columns.push({
            title: () => i18n.global.t("views.company.companyDocReject.samplingProduct.testReport"),
            sorter: false,
            width: 150,
            align: "center",
            visible: () => true,
            search: { visible: () => false },
            customRender: ({ record }) => {
                if (!["Accept", "Reject"].includes(record.refAcceptanceStatus?.key)) {
                    return null;
                }
                return (
                    <Button
                        class="btn-primary m-2"
                        size="small"
                        onClick={() => {
                            const reports = record.analysiss.map(d => {
                                return {
                                    visible: () => true,
                                    fileName: `Reject Form ${d.refLabType.valueEn}.pdf`,
                                    callReport: () =>
                                        onClickReport({
                                            fileName: `Reject Form ${d.refLabType.valueEn}.pdf`,
                                            callReport: () => {
                                                const { createConditionReport } = require("../../lab/sampling-product-analysis/analysis.report");
                                                const { callJasperReportByKey } = require("../../lab/sampling-product-analysis/analysis.logic");
                                                const report = createConditionReport().rejectionForm({ modelRef: d });
                                                return callJasperReportByKey({ data: { ...report, attribute: { id: d.id } } });
                                            }
                                        })
                                };
                            });
                            openModalReportList({ props, data: { reports } });
                        }}
                    >
                        <span>{i18n.global.t("model.samplingProductAnalysis.buttons.testReport")}</span>
                        <CIcon file={"report.svg"}></CIcon>
                    </Button>
                );
            }
        });
    }
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visibleCompanyDocReject, visibleSamplingProduct } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [createManageExportCsv({ menuContext })];
    data.manageExtras = [];
    data.rowActions = [];

    if (!viewOnly) {
        if (visibleCompanyDocReject) {
            /*
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalListCompany({
                            onIframeMounted: ({ refs, options }) => onIFrameClickSelectAll({
                                refs, options, items, itemKey: 'refCompany.id', rowKey: 'id', setKey: 'refCompany'
                            }),
                        }),
                        options: { text: i18n.global.t('model.companyCountry.refCompany') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }),
            })
            */
        }
        if (visibleSamplingProduct) {
            //
        }
    }
};

export const createField = () => {
    return [];
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = () => {
    const promises = [];
    return Promise.all(promises);
};

export const initForm = ({ props, data, refs }) => {
    data.form = props.form ? props.form : {};
    data.rules = {};
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
